import React, {useEffect, useRef} from 'react'
import {useCustomerId} from '@salesforce/commerce-sdk-react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {useWishlistActions} from '../../../hooks/use-wishlist-actions'
import {
    clearPendingWishlist,
    getPendingWishlist,
    PENDING_WISHLIST_ACTION
} from '../../../utils/wishlist-utils'

const PendingWishlistReplay = () => {
    const customerId = useCustomerId()
    const {data: customer} = useCurrentCustomer()
    const {addItemToWishlist, isInWishlist} = useWishlistActions()
    const pendingWishlistReplayRef = useRef(null)

    useEffect(() => {
        if (typeof window === 'undefined') return
        if (!customer?.isRegistered || !customerId) return

        const pendingWishlistAction = getPendingWishlist()
        if (!pendingWishlistAction) {
            pendingWishlistReplayRef.current = null
            return
        }

        if (pendingWishlistAction.type !== PENDING_WISHLIST_ACTION.ADD) return

        const {
            productId: pendingProductId,
            interactionLocation
        } = pendingWishlistAction

        if (pendingWishlistReplayRef.current === pendingProductId) return

        pendingWishlistReplayRef.current = pendingProductId

        if (isInWishlist(pendingProductId)) {
            clearPendingWishlist()
            return
        }

        addItemToWishlist({productId: pendingProductId}, null, interactionLocation)
    }, [customer?.isRegistered, customerId, isInWishlist, addItemToWishlist])

    return null
}

export default PendingWishlistReplay
